import { ValidatorFn } from '@angular/forms';
import { Question } from '../../../../../classes';
import { isInteger } from 'lodash';

export function questionMaxCheckedOptionCntValidator (question:Question):ValidatorFn {
    return (): { [key: string]: boolean } => {
        if (typeof question.max_checked_option_cnt === 'number') {
            if (!isInteger(question.max_checked_option_cnt)) {
                return {
                    not_integer:true,
                }
            }
            else if (question.max_checked_option_cnt <= 0) {
                return {
                    not_positive:true,
                }
            }
            else if (question.max_checked_option_cnt > question.getOptions(o=>o.type === 'number').length) {
                return {
                    over_option_length:true,
                }
            } 
        }
        return null;
    }    
}
